const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const StoreManagerPermissionCommand: any = {
    SetGrant: Backofficebff + '/v1/store-manager-permission/grant',
};
